var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.63621 0.333008C0.915932 0.333008 0.332031 0.92422 0.332031 1.65352C0.332031 2.38282 0.915932 2.97403 1.63621 2.97403H3.84508C4.449 2.97403 4.97393 3.39385 5.1138 3.98871L6.18906 8.56189C6.20827 8.64357 6.23458 8.72165 6.26718 8.79563L8.36626 18.0885C8.63749 19.2892 9.69246 20.1407 10.909 20.1407H24.9679C26.1844 20.1407 27.2394 19.2892 27.5106 18.0885L29.5986 8.84489C29.9721 7.19131 28.7312 5.61505 27.0559 5.61505H10.865L10.8668 5.62272H8.18796L8.18619 5.61505H8.17745L7.65124 3.37706C7.23164 1.59247 5.65686 0.333008 3.84508 0.333008H1.63621ZM8.79694 8.25806L9.88662 12.9736L10.909 17.4996H24.9679L27.0559 8.25607H12.5847V8.25806H8.79694Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6343 27.0381C16.6343 29.226 14.8826 30.9997 12.7217 30.9997C10.5609 30.9997 8.8092 29.226 8.8092 27.0381C8.8092 24.8502 10.5609 23.0766 12.7217 23.0766C14.8826 23.0766 16.6343 24.8502 16.6343 27.0381ZM14.0259 27.0381C14.0259 27.7674 13.442 28.3587 12.7217 28.3587C12.0015 28.3587 11.4176 27.7674 11.4176 27.0381C11.4176 26.3088 12.0015 25.7176 12.7217 25.7176C13.442 25.7176 14.0259 26.3088 14.0259 27.0381Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0677 27.0381C27.0677 29.226 25.316 30.9997 23.1552 30.9997C20.9943 30.9997 19.2426 29.226 19.2426 27.0381C19.2426 24.8502 20.9943 23.0766 23.1552 23.0766C25.316 23.0766 27.0677 24.8502 27.0677 27.0381ZM24.4594 27.0381C24.4594 27.7674 23.8754 28.3587 23.1552 28.3587C22.4349 28.3587 21.851 27.7674 21.851 27.0381C21.851 26.3088 22.4349 25.7176 23.1552 25.7176C23.8754 25.7176 24.4594 26.3088 24.4594 27.0381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart_icon.4d579e88acf81a3c5ddaf23af612e7a5.svg";
export { ForwardRef as ReactComponent };